import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {JsonPipe} from '@angular/common';
import * as dayjs from 'dayjs';

@Component({
  selector: 'tmw-date-range',
  standalone: true,
  imports: [NgbDatepickerModule, FormsModule, JsonPipe],
  templateUrl: './date-range.component.html',
  styleUrl: './date-range.component.scss',
})
export class TmwDateRangeComponent {
  calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);

  hoveredDate: NgbDate | null = null;

  @Output() dateFromChange = new EventEmitter();
  @Input() set dateFrom(dt: any) {
    this.fromDate = this.toNgbDate(dt);
  }
  fromDate: NgbDate | null = this.calendar.getToday();

  @Output() dateToChange = new EventEmitter();
  @Input() set dateTo(dt: any) {
    this.toDate = this.toNgbDate(dt);
  }
  toDate: NgbDate | null = this.calendar.getNext(this.calendar.getToday(), 'd', 10);

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.dateFromChange.emit(this.toJsDate(this.fromDate));
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      this.dateToChange.emit(this.toJsDate(this.toDate));
    } else {
      this.toDate = null;
      this.dateToChange.emit(this.toJsDate(this.toDate));
      this.fromDate = date;
      this.dateFromChange.emit(this.toJsDate(this.fromDate));
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  toNgbDate(date: any) {
    let result = null;
    if (date) {
      let djs = dayjs(date);
      result = new NgbDate(djs.year(), djs.month() + 1, djs.date());
    }
    return result;
  }

  toJsDate(ngbDate: any) {
    let result = null;
    if (ngbDate) {
      result = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, 11);
    }
    return result;
  }
}
